'use client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsMobileScreen } from '@/store/reducers/appSlice';

const MOBILE_BREAKPOINT = 768; // Standard breakpoint for mobile devices

export default function MobileScreenDetector() {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      dispatch(setIsMobileScreen(isMobile));
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dispatch]);

  return null;
} 